<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
	  <el-button type="primary" @click="handleExport"
	    ><i class="el-icon-download"></i> 导出</el-button
	  >
      <BaseTable
        ref="baseTable"
        url="/admin/Census/serviceUsageList"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
      >
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "usage",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {date: [this.$moment().format("YYYY-MM-DD 00:00:00"),this.$moment().format("YYYY-MM-DD 23:59:59")]},
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
	this.$store.dispatch('app/getCarType')
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
	async handleExport() {
	  const res = await this.$api.post(
	    "/admin/Census/serviceUsageList",
	    { is_export: 1, ...this.searchData },
	    "导出"
	  );
	  window.open("https://" + res.data);
	},
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
